import { Component, OnInit } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";

@Component({
  selector: 'app-challenges-table',
  templateUrl: './challenges-table.component.html',
  styleUrls: ['./challenges-table.component.scss']
})
export class ChallengesTableComponent implements OnInit {
  displayedColumns=['sr','childName','totalSessions','from','to','createdAt','actions']
  dataSource: any[] = []; // Data source for the table
  constructor(private mFirestore: AngularFirestore,
              private mSnackbar:MatSnackBar,
              private mRouter:Router) { }

  ngOnInit(): void {
  }

  addReport() {
    this.mRouter.navigateByUrl('home/reports/challenges')
  }

  ViewReport(id:any) {

  }

  deleteReport(id:any) {

  }
}
